/** @format */

// File: src/components/relays/RelayEventSelector.jsx
// Version: 3.2.2

import { memo } from "@wordpress/element";

const RelayEventSelector = ({ relayEvents, activeEvent, setActiveEvent, declaredTeams }) => {
    return (
        <div className="list-group shadow-sm rounded border border-light-subtle bg-white">
            <div className="list-group-item bg-light border-0 py-3">
                <h6 className="fw-bold mb-0 text-secondary text-uppercase tracking-wider small" style={ { letterSpacing: "0.5px" } }>Relay Categories</h6>
            </div>
            { relayEvents.map((ev) => {
                const squadCount = declaredTeams.filter(t => Number(t.scheduleId) === Number(ev.id)).length;
                const isCurrent = activeEvent && Number(activeEvent.id) === Number(ev.id);

                return (
                    <button
                        key={ `relay-event-btn-${ ev.id }` }
                        type="button"
                        className={ `list-group-item list-group-item-action border-start-0 border-end-0 py-3 px-3 d-flex justify-content-between align-items-center ${ isCurrent ? "active fw-semibold border-primary" : "" }` }
                        onClick={ () => setActiveEvent(ev) }
                    >
                        <div className="pe-2">
                            <div className={ `text-uppercase small ${ isCurrent ? "text-white" : "text-dark" }` }>{ ev.disciplineName }</div>
                            <div className={ `text-uppercase mt-1` } style={ { fontSize: "10px", opacity: 0.85 } }>
                                { ev.ageClass || "Open" } • { ev.sexCode || "Mixed" }
                            </div>
                        </div>
                        { squadCount > 0 && (
                            <span className={ `badge rounded-pill ${ isCurrent ? "bg-white text-primary" : "bg-primary text-white" }` }>
                                { squadCount }
                            </span>
                        ) }
                    </button>
                );
            }) }
        </div>
    );
};

export default memo(RelayEventSelector);